var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpLasku(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 111",
    style: {
      enableBackground: "new 0 0 400 111"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -143,
    style: {
      fill: "none"
    },
    width: 400,
    height: 400
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6E6E"
    },
    d: "M51.5-92.5v-21.9c0-14.3-6.4-28.5-25.6-28.5c-19.3,0-25.7,14.3-25.7,28.5v21.9 c0,14.3,6.4,28.5,25.7,28.5C45.1-63.9,51.5-78.2,51.5-92.5z M44.6-92.5c0,12-4.7,22.1-18.7,22.1c-14.1,0-18.8-10-18.8-22.1v-21.9 c0-12,4.7-22.1,18.8-22.1c13.9,0,18.7,10,18.7,22.1V-92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6E6E"
    },
    d: "M113.5-116.2v-5.4 c0-9.8-6.4-20.3-24.3-20.3H69c-1.9,0-3.5,1.6-3.5,3.5v71c0,2,1.6,3.5,3.5,3.5c2,0,3.5-1.5,3.5-3.5v-28.9h17.9 C104.9-96.4,113.5-104.6,113.5-116.2z M106.5-116.3c0,7.4-5.1,13.5-16.4,13.5H72.5v-32.5h16.4c13.8,0,17.7,7.6,17.7,13.8V-116.3z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6E6E"
    },
    d: "M197.1-68.2c0-1.9-1.5-3.5-3.3-3.5h-34.1v-67.7c0-1.9-1.5-3.5-3.5-3.5c-1.9,0-3.5,1.6-3.5,3.5 v71.2c0,1.8,1.5,3.3,3.4,3.3h37.6C195.7-64.9,197.1-66.4,197.1-68.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6E6E"
    },
    d: "M242.9-67.3c0-1.2-0.5-2.1-1.7-2.6 c-2.3-1-3-2.3-3-6.9v-20.8c0-12.9-3.8-20.4-18.6-20.4c-4.1,0-8.3,0.5-11.7,1.9c-2.7,1.2-4.5,2.5-4.5,4.3c0,1.6,1.3,2.9,2.8,2.9 c1.3,0,2.3-0.8,4.7-1.9c2.1-0.8,4.6-1.4,8.4-1.4c10,0,12.3,4.6,12.3,14.2v3h-13.2c-13.4,0-18.7,6.7-18.7,14.9v0.8 c0,8.1,4.9,15.1,18.1,15.1c4.6,0,10.9-1.1,14.7-5.9c0.5,1.6,1.4,3.2,2.5,4.2c1.3,1.1,2.7,1.7,4.4,1.7 C241.5-64.3,242.9-65.3,242.9-67.3z M231.6-82.5c0,8.5-4.8,12.6-13,12.6c-9.8,0-12.3-4.5-12.3-9.4v-0.7c0-4.8,2.5-9.4,12.5-9.4 h12.8V-82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6E6E"
    },
    d: "M284.9-80c0-10.8-7.9-12.8-15.5-14.4 c-6.9-1.4-13.5-2.3-13.5-8.9c0-5.2,3.8-8.9,10.9-8.9c4.4,0,7.2,0.6,10.7,2c1.7,0.7,3.3-0.2,3.9-1.6c0.6-1.6,0.1-3.5-1.7-4.1 c-3.9-1.7-7.6-2.2-13-2.2c-10,0-17.2,5.5-17.2,15c0,9.9,6.9,12.3,14.1,13.8c7.4,1.6,14.9,2.1,14.9,9.4c0,5.6-3.7,9.5-12.5,9.5 c-5.9,0-9.1-0.7-12.6-2c-1.7-0.7-3.4,0.1-3.9,1.7c-0.6,1.5-0.1,3.4,1.7,4c4.1,1.6,8.2,2.3,14.7,2.3 C277.4-64.3,284.9-69.8,284.9-80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6E6E"
    },
    d: "M332-69c-4.9-9.6-11.2-19.2-17.6-27.8 l15.6-16.1c1.3-1.2,1.3-3.2,0.1-4.3c-1.3-1.2-3.1-1.2-4.4,0l-24.1,24.9V-138c0-1.9-1.6-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4v70.4 c0,1.9,1.5,3.4,3.4,3.4c1.8,0,3.4-1.5,3.4-3.4v-16.2l8.1-8.3c6,8,11.9,17,16.5,26c0.6,1.4,1.8,1.9,2.8,1.9 C331.1-64.3,333.2-66.4,332-69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6E6E"
    },
    d: "M383-67.3c0-1.2-0.6-2.1-1.8-2.6 c-2.3-1-3.4-2.2-3.4-6.9v-37.8c0-1.9-1.5-3.4-3.4-3.4s-3.4,1.4-3.4,3.4v35.5c-2.4,5.1-7.1,8.3-14.7,8.3c-9,0-11.2-4.9-11.2-12.9 v-31c0-2-1.5-3.4-3.4-3.4c-1.8,0-3.4,1.4-3.4,3.4v31.4c0,10.6,3.8,19,17,19c7.6,0,12.9-2.4,16.5-6.6c0.4,1.6,1.3,3.1,2.6,4.3 c1.4,1.4,3.7,2.2,5,2.2C381.4-64.3,383-65.3,383-67.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpLasku);
export default __webpack_public_path__ + "static/media/op-lasku.72540d2bdaeaeca60634051481621e73.svg";
export { ForwardRef as ReactComponent };